import React, { useState } from "react";
import HeaderSearch from "./HeaderSearch";
import CardPosts from "../Cards/CardPost";
import axios from "../../helpers/axios";
import { ENDPOINT_SEARCH_POSTS } from "../../helpers/endpoints";
import { useDispatch, useSelector } from "react-redux";
export default function Conversations({ options, categories }) {
  const [categoriesSelected, setCatetories] = useState([]);
  const [search, setSearch] = useState("");
  const [posts, setPosts] = useState([]);
  React.useEffect(() => {
    axios
      .get(
        ENDPOINT_SEARCH_POSTS(
          search,
          categoriesSelected.map(e => e.value)
        )
      )
      .then(({ data }) => {
        if (data) setPosts(data);
      });
  }, [categoriesSelected, search]);
  const handlingChange = e => {
    if (e === null) setCatetories([]);
    else setCatetories(e);
  };
  const handlingSearch = e => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  const { postId, username, name, userId } = useSelector(state => ({
    ...state.Post,
    ...state.User
  }));
  const dispatch = useDispatch();
  const closeSideBar = () => {
    dispatch({
      type: "CLOSE_SIDEBAR"
    });
  };
  const changePost = (post, title, urlImg, creator) => {
    dispatch({
      type: "SWITCH_POST",
      payload: { postId,  post,  userId }
    });
    dispatch({
      type: "CHANGE_POST",
      payload: { postId: post, creator, urlImg, title }
    });
  };
  const Posts = ({ posts }) =>
    posts.map(post => (
      <CardPosts
        {...post}
        key={post._id}
        changePost={changePost}
        postId={postId}
        closeSideBar={closeSideBar}
      />
    ));

  return (
    <section
      className={
        options === 1 ? "categories active scroll" : "categories scroll"
      }
    >
      <HeaderSearch
        categories={categories}
        search={search}
        categoriesSelected={categoriesSelected}
        handlingChange={handlingChange}
        handlingSearch={handlingSearch}
      />
      <div id="posts" className="posts">
        <Posts posts={posts} />
      </div>
    </section>
  );
}
